/**
 * CheckableMapTag.jsx
 *
 * @Author: zhangce
 * @Date: 17/8/23 上午11:37
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * CheckableMapTag
 * */
class CheckableMapTag extends React.PureComponent {
    static propTypes = {
        /**
         * 类前缀
         * */
        prefixCls: PropTypes.string,
        /**
         * 类名
         * */
        className: PropTypes.string,
        /**
         * 是否被选中
         * */
        checked: PropTypes.bool,
        /**
         * 是否禁用
         * */
        disabled: PropTypes.bool,
        /**
         * 标签大小
         * */
        size: PropTypes.oneOf(['small', 'medium', 'large']),
        /**
         * 选中状态改变回调
         * */
        onChange: PropTypes.func,
    };

    static defaultProps = {
        prefixCls: 'ne-maptag',
        checked: false,
        size: 'medium',
        disabled: false,
    };

    handleClick = () => {
        const { checked, onChange, disabled } = this.props;
        if (onChange && !disabled) {
            onChange(!checked);
        }
    };

    render() {
        const { children, prefixCls, checked, className, size, disabled, ...other } = this.props;
        const classString = classNames(
            prefixCls,
            `${prefixCls}-checkable`,
            `${prefixCls}-${size}`,
            {
                [`${prefixCls}-checked`]: checked,
                [`${prefixCls}-disabled`]: disabled,
            },
            className,
        );
        return (
            <span className={classString} onClick={this.handleClick} {...other}>
                {children}
            </span>
        );
    }
}

export default CheckableMapTag;



// WEBPACK FOOTER //
// ./src/maptag/CheckableMapTag.jsx